import { useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { setOfficeInfoData, setUserSelectedClerkId } from '../../../redux/userDucks';
import useUserStore from '../../../redux/utils/storeUtils';
import styles from './styles.module.scss';
import { OfficeInformationService } from '../../../services/OfficeInformationService';
import { SUCCESSFUL_REQUEST_CODE } from '../../../utils';

const JurisdictionSelect = () => {
	const { userClerks, selectedClerkId, selectedClerk } = useUserStore();
	const { officeInformation } = useSelector((state) => state.user);
	const dispatch = useDispatch();
	const jurisdictionTopMenuRef = useRef(null);
	const { getOfficeInformation } = OfficeInformationService();

	const handleJurisdictionSelect = (clerkId) => {
		dispatch(setUserSelectedClerkId(clerkId));
		dispatch(setOfficeInfoData({}));
		window.location.reload();
	};

	const fetchJurisdictionData = async () => {
		try {
			const response = await getOfficeInformation(selectedClerkId);
			if (SUCCESSFUL_REQUEST_CODE.includes(response.status)) {
				dispatch(setOfficeInfoData(response.data));
			} else {
				dispatch(setOfficeInfoData({}));
			}
		} catch (error) {
			dispatch(setOfficeInfoData({}));
			console.error(error);
		}
	};

	useEffect(() => {
		fetchJurisdictionData();
	}, []);

	useEffect(() => {
		function focusJurisdictionTopMenu(event) {
			if (event.keyCode === 74 && event.altKey) {
				jurisdictionTopMenuRef.current.focus();
			}
		}

		document.addEventListener('keydown', focusJurisdictionTopMenu);

		return () => {
			document.removeEventListener('keydown', focusJurisdictionTopMenu);
		};
	});

	return (
		<>
			<div role="navigation" aria-label="Jurisdiction Menu">
				<ul className={`${styles.jurisdictionTopMenu} navbar-nav`}>
					<li className="visually-hidden">Select Jurisdiction</li>
					<li className="nav-item dropdown">
						<a
							aria-expanded="false"
							className="nav-link"
							data-bs-toggle="dropdown"
							href="/#"
							id="JurisdictionDropdown"
							role="button"
							ref={jurisdictionTopMenuRef}
							style={{
								backgroundColor: officeInformation?.officePrimaryColor,
								color: officeInformation?.officeSecondaryColor
							}}
						>
							{!isEmpty(userClerks) ? (
								<>
									<div>
										{!isEmpty(selectedClerk)
											? selectedClerk.countyCodeDescription
											: !isEmpty(userClerks)
											? userClerks[0].countyCodeDescription
											: ''}
									</div>
									<div>
										{!isEmpty(selectedClerk)
											? selectedClerk.clerkTypeDescription
											: !isEmpty(userClerks)
											? userClerks[0].clerkTypeDescription
											: ''}
									</div>
								</>
							) : (
								<>
									<div>Jurisdiction</div>
									<div>N/A</div>
								</>
							)}
							<i className="fas fa-caret-down"></i>
						</a>
						<ul aria-labelledby="JurisdictionDropdown" className="dropdown-menu">
							<li>
								<span>Jurisdiction</span>
							</li>
							{!isEmpty(userClerks) ? (
								userClerks.map((item, index) => (
									<li key={index}>
										<button onClick={() => handleJurisdictionSelect(item.clerkId)}>
											{item.jurisdiction}
										</button>
										{selectedClerkId && selectedClerkId === item.clerkId ? (
											<i className="fas fa-circle"></i>
										) : (
											<i></i>
										)}
									</li>
								))
							) : (
								<>
									<li>
										<button className="text-center">No Jurisdiction available</button>
									</li>
								</>
							)}
						</ul>
					</li>
				</ul>
			</div>
		</>
	);
};

export default JurisdictionSelect;
